import { readCampaignStaleConflict, StoredCampaignEntry } from "./campaignRevision.util";

/**
 * Write the settings modal's fields onto a campaign, recovering once from `409 CAMPAIGN_STALE`
 * (PREC-4390).
 *
 * The builder flushes its canvas when the settings modal opens (PREC-4151), and that save can move
 * the campaign's revision past the copy the modal was handed, so the modal's own write was refused
 * as stale — five of the latest 25 events in Bugsink SIGNALIST-4, each a Save that did nothing. The
 * modal owns only its settings fields; the sequence and its validity are the builder's. So the
 * settings are laid over the entry the server reports as current and written once more, which keeps
 * the newer sequence. A campaign that no longer exists is not written back, and any other failure
 * is left to the caller to report.
 */
export async function writeCampaignSettings<T>({
	campaignUuid,
	storedEntry,
	settings,
	write,
}: {
	campaignUuid: string;
	storedEntry: StoredCampaignEntry | undefined;
	settings: Record<string, unknown>;
	write: (entry: StoredCampaignEntry) => Promise<T>;
}): Promise<T> {
	try {
		return await write({ ...storedEntry, ...settings });
	} catch (error) {
		const conflict = readCampaignStaleConflict(error);

		if (!conflict || conflict.campaignId !== campaignUuid || !conflict.current) {
			throw error;
		}

		return await write({ ...conflict.current, ...settings });
	}
}
